import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addDays, differenceInDays, format, isAfter, isSameDay } from 'date-fns';

import { Motion, spring } from 'react-motion';
import { manageTranslations as TranslationHelper } from '@morsedigital/i18n_helper';

import { GetSessions } from '../../actions/sessions';
import { createDates } from '../../actions/date_nav';

import NavWrapper from './nav_wrapper';
import NavItem from './nav_item';
import MobileDisplay from './presentational/mobile_display';
import ArrowLeft from './presentational/arrow_left';
import ArrowRight from './presentational/arrow_right';

// const createDates = (start = new Date(), create = 14) => {
//   // const date = new Date();
//   let i = 0;
//   // const fmt = (device === 'mobile') ? 'ddd do' : 'ddd do';
//   const dates = [];
//   do {
//     i += 1;
//     dates.push(addDays(start, i));
//   } while (i < create);

//   return dates;
// };

const getWidth = items =>
  items
    .filter(({ el }) => el !== null)
    .reduce((w, { el }) => {
      const { width } = el.getBoundingClientRect();
      const newWidth = w + width;
      return newWidth;
    }, 0);

const wp = TranslationHelper('javascript')('weekly_programme');

export class DateNavComponent extends Component {
  static propTypes = {
    CreateDates: PropTypes.func.isRequired,
    dates: PropTypes.array.isRequired,
    selectedDate: PropTypes.instanceOf(Date).isRequired,
  };

  state = {
    dates: createDates(),
    dragging: false,
    offset: 0,
    position: 0,
    startPosition: { screenX: 0, screenY: 0 },
    // width: 0,
  };

  constructor(props) {
    super(props);
    this.moved = 0;
    this.dateWrapper = null;
    this.dateList = null;
    this.dateItems = [];
  }

  componentDidMount() {
    const width = getWidth(this.dateItems);
    // Need offset of first item to fix safari bug
    const offset = this.dateItems[0].el.offsetLeft;
    /* eslint-disable */
    this.setState({
      move: width / this.dateItems.length,
      offset,
      width,
    });
    /* eslint-enable */
  }

  componentWillUpdate(oldProps, { position }) {
    const { CreateDates } = this.props;
    this.dateItems = this.dateItems.filter(({ el }) => el !== null);
    const width = getWidth(this.dateItems);
    const { width: wrapperWidth } = this.dateWrapper.getBoundingClientRect();

    if (width - wrapperWidth < Math.abs(position)) {
      CreateDates(7);
    }
  }

  componentDidUpdate({ selectedDate: oldDate }, { position, width: oldWidth }) {
    this.setMovements();
    // has to be here as can't set position until components are rendered
    const { selectedDate } = this.props;
    const { offset } = this.state;
    if (!isSameDay(oldDate, selectedDate)) {
      const dateItem = this.dateItems.find(({ id }) => isSameDay(id, selectedDate));
      /* eslint-disable */
      if (dateItem && dateItem.el) {
        const { left } = dateItem.el.getBoundingClientRect();
        // Removing the offset fixes stupid safari bug
        this.setState({ position: -dateItem.el.offsetLeft + offset});
      } else {
        this.setState({ position: 0 });
      }
      /* eslint-enable */
    }
  }

  setMovements = () => {
    const width = getWidth(this.dateItems);
    if (width !== this.width) {
      this.width = width;
      this.move = width / this.dateItems.length;
    }
  };

  moveLeft = e => {
    e.preventDefault();

    this.setState(({ position }) => {
      const moved = position + this.move;
      return {
        position: moved <= 0 ? moved : 0,
      };
    });
  };

  moveRight = e => {
    e.preventDefault();
    this.setState(({ position }) => ({
      position: position - this.move,
    }));
  };

  checkMove = (start, end) => Math.abs(start - end);

  dragStart = e => {
    this.setState({ dragging: true, startX: e.clientX });
  };

  dragMove = e => {
    const { dragging, position, startX } = this.state;
    const moved = e.clientX - startX;
    const newPosition = e.clientX;
    if (dragging) {
      const newPos = position + moved;
      this.setState({
        position: newPos <= 0 ? newPos : 0,
        startX: newPosition,
      });
    }
  };

  dragEnd = e => {
    this.setState({ dragging: false });
  };

  touchStart = e => {
    const { screenX, screenY } = e.changedTouches[0];
    this.setState({ startPosition: { screenX, screenY } });
  };

  touchEnd = e => {
    const { startPosition } = this.state;
    const { screenX } = e.changedTouches[0];

    if (this.checkMove(startPosition.screenX, screenX)) {
      this.setState(({ position }) => {
        const move = startPosition.screenX - screenX;
        const newPosition = position - move > 0 ? 0 : position - move;
        return {
          position: newPosition,
        };
      });
    }
  };

  formatDates = (d, device) => {
    if (device === 'mobile') return <MobileDisplay date={format(d, 'Do')} day={format(d, 'ddd')} />;
    return format(d, 'ddd Do');
  };

  renderDates = () => {
    const { dates } = this.props;
    this.dateItems = [];
    return dates.map(date => (
      <li
        key={date.toJSON()}
        className="date-list__item"
        ref={el => {
          if (el !== null) {
            this.dateItems.push({ el, id: date });
          }
        }}
      >
        <NavItem date={date} formatter={this.formatDates} />
      </li>
    ));
  };

  render() {
    const { position } = this.state;
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    return (
      <nav className="date-nav">
        <ArrowLeft onClick={this.moveLeft} />
        <div role="presentation" className="date-list__item--today">
          <NavItem date={new Date()} formatter={this.formatDates} />
        </div>
        <div
          className="date-list"
          ref={el => {
            this.dateWrapper = el;
          }}
          onMouseDown={this.dragStart}
          onMouseMove={this.dragMove}
          onMouseUp={this.dragEnd}
          onTouchStart={this.touchStart}
          onTouchMove={this.touchMove}
          onTouchEnd={this.touchEnd}
        >
          <NavWrapper
            position={position}
            getRef={el => {
              this.dateList = el;
            }}
            renderItems={this.renderDates}
          />
        </div>

        <ArrowRight onClick={this.moveRight} />
      </nav>
    );
    /* eslint-enable jsx-a11y/no-static-element-interactions */
  }
}

const mapStateToProps = ({ dateNav: { datesList }, sessions: { selectedDate } }) => ({
  dates: datesList,
  // device: general.device,
  selectedDate,
});

const mapDispatchToProps = dispatch => ({
  CreateDates: days => dispatch(createDates(days)),
  GetSessionsData: date => dispatch(GetSessions(date)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DateNavComponent);
